import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import PaymentBadge from 'app/components/general/PaymentBadge';
import Isvg from 'react-inlinesvg';
import tick from 'app/images/icons/tick.svg';

// Misc


export default class EventCard extends React.Component {
  static propTypes = {
    handleEventClick: PropTypes.func,
    event: PropTypes.object,
    status: PropTypes.string,
    groupOneName: PropTypes.string,
    groupTwoName: PropTypes.string,
    eventDescription: PropTypes.string,
    eventTime: PropTypes.string,
    eventSection: PropTypes.string,
    eventLocation: PropTypes.string,
    groupOneChecked: PropTypes.bool,
    groupTwoChecked: PropTypes.bool,
    groupOnePaymentText: PropTypes.string,
    groupTwoPaymentText: PropTypes.string,
    selected: PropTypes.bool,
  };

  static defaultProps = {
    handleEventClick: undefined,
    event: {},
    status: 'Pending',
    eventDescription: '',
    eventTime: '',
    eventSection: '',
    eventLocation: '',
    groupOneName: '',
    groupTwoName: '',
    groupOnePaymentText: '',
    groupTwoPaymentText: '',
    groupOneChecked: true,
    groupTwoChecked: false,
    selected: false,
  };

  handleClick = () => {
    this.props.handleEventClick(this.props.event.id);
  };

  cardColor = (status) => {
    let color = 'grey';
    if (status === 'Overdue') {
      color = 'red';
    }
    if (status === 'Cancelled') {
      color = 'black';
    }
    if (status === 'Walkover' || status === 'Forfeit') {
      color = 'black';
    }
    if (status === 'No-show') {
      color = 'black';
    }
    if (status === 'Paid') {
      color = 'green';
    }
    return color;
  };

  render(): React.ReactNode {
    const color = this.cardColor(this.props.status);

    return (
      <div className={classnames('event-card', { selected: this.props.selected })} onClick={this.handleClick}>
        <Card>
          <div className="event-card-row">
            <div className="event-card-row-text">
              <div className="event-card-text">{this.props.groupOneName}</div>
              <PaymentBadge
                className="event-card-badge ml-auto"
                paymentText={this.props.groupOnePaymentText}
              />
            </div>
          </div>
          <div className="event-card-row">
            <div className="event-card-row-text">
              <div className="event-card-text">{this.props.groupTwoName}</div>
              <PaymentBadge
                className="event-card-badge ml-auto"
                paymentText={this.props.groupTwoPaymentText}
              />
            </div>
          </div>
          <div className="event-card-description">
            <div className="event-card-description-row">
              {this.props.eventSection}
            </div>
            <div className="event-card-description-row">
              {this.props.eventLocation}
            </div>
          </div>
          <div className={`event-card-status ${color}`}>
            {this.props.status}
            {' '}
            {color === 'green' && <Isvg className="tick" src={tick} />}
          </div>
        </Card>
      </div>
    );
  }
}
